<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Client_PO_Title' | translateWF: 'Client Purchase Orders' }}
        </h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button (click)="redirectToDetails('new')" [label]="'Client_PO_Create' | translateWF: 'Create Client PO'" icon="pi pi-plus" iconPos="left"></p-button>
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Client_PO_Title' | translateWF: 'Client Purchase Orders'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listClientPOs()" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" selectionMode="single" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="number">
                  {{ 'Client_PO_Number' | translateWF: 'CPO Number' }}
                  <p-sortIcon field="number"></p-sortIcon>
                </th>
                <th>{{ 'Client_PO_Client' | translateWF: 'Client' }}</th>
                <th>{{ 'Client_PO_Type' | translateWF: 'Type' }}</th>
                <th pSortableColumn="issuedDate">
                  {{ 'Client_PO_Issued_Date' | translateWF: 'Issued Date' }}
                  <p-sortIcon field="issuedDate"></p-sortIcon>
                </th>
                <th pSortableColumn="status">
                  {{ 'Client_PO_Status' | translateWF: 'Status' }}
                  <p-sortIcon field="status"></p-sortIcon>
                </th>
                <th>{{ 'Client_PO_Items' | translateWF: 'Items' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let cpo = getRowData(rowData);
              <tr class="cursor-pointer">
                <td (click)="redirectToDetails(cpo.id)">
                  <a>{{ cpo.number }}</a>
                </td>
                <td (click)="redirectToDetails(cpo.id)">{{ cpo.client?.name || cpo.client?.code || '-' }}</td>
                <td (click)="redirectToDetails(cpo.id)">{{ types()[cpo.type] || '-' }}</td>
                <td (click)="redirectToDetails(cpo.id)">{{ cpo.createdDate | date: 'dd/MM/yyyy' }}</td>
                <td (click)="redirectToDetails(cpo.id)">{{ statuses()[cpo.status] }}</td>
                <td (click)="redirectToDetails(cpo.id)">{{ cpo.items.length || 0 }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">
                  {{ 'Client_PO_No_Orders_Found' | translateWF: 'No client purchase orders found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            dropdownAppendTo="body"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
